module.exports = __webpack_public_path__ + "static/1Start_circle-712d2b11b965050e2a7e480bd4a12667.gif";